import { DisplayButton } from '@xo-union/tk-ui-links';
import React from 'react';

import styles from './linkButton.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: any;
  className?: string;
}

const LinkButton: React.FC<Props> = ({ children, className = '', ...props }) => (
  <DisplayButton className={`${styles.link} ${className}`} {...props}>
    {children}
  </DisplayButton>
);

export default LinkButton;
